import { computed, watch } from "vue";
import { useAuthStore } from "../store/auth";
import { useMyRoutesStore } from "../store/myRoutes";
import { useRoutesStore } from "../store/routes";

// Маршруты для поиска и «Маршрутов рядом»: публичный каталог (каталожные и
// опубликованные пользователями) плюс собственные приватные маршруты вошедшего
// пользователя - их в публичном списке нет.
export function useSearchableRoutes() {
  const routes = useRoutesStore();
  const mine = useMyRoutesStore();
  const auth = useAuthStore();
  watch(
    () => auth.isAuthenticated,
    (authed) => {
      if (authed) void mine.fetch();
    },
    { immediate: true }
  );
  return computed(() => {
    const seen = new Set(routes.items.map((r) => r.id));
    return [...routes.items, ...mine.items.filter((r) => !seen.has(r.id))];
  });
}
